// @ts-nocheck
import * as React from 'react';
import * as ReactDom from 'react-dom';
import $ from 'jquery';
import { ReeferMapGrid } from '../childcomponents/ReeferMapGrid';
import { AdvanceSearch } from '../childcomponents/AdvanceSearch';
import { ReeferMap } from '../childcomponents/ReeferMap';
import passed from '../../images/passed.png';
import failed from '../../images/failed.png';
import aborted from '../../images/aborted.png';
import runningtime from '../../images/running-time.png';
import questionMark from '../../images/questionMark.png';
import batterycritical from '../../images/battery-critical.svg';
import batterylow from '../../images/battery-low.svg';
import batterynormal from '../../images/battery-normal.svg';
import lodashfilter from 'lodash/filter';
var Config: any = require('../../Config.json');
var DateFormat = require('dateformat');
var tempFormat;
var timeFormat;
var PTReport;
var ReportReeferId;

export class PinInfoboxDescription extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        tempFormat = GetTempColumnFormatter();
        timeFormat = GetTimeZoneFormatter().toString();
        PTReport = '';
        ReportReeferId = '';        
    }
    componentDidMount() {
        $('#ancResolveaddress_' + this.props.divid).click(this.ResolveAddress.bind(this));
        $('#PreTripReport_' + this.props.divid).click(this.popUpGetPTIReport.bind(this));
        //$('.infobox-close').click(this.DisablePushpinHover.bind(this));
        $("#status" + this.props.divid).show();
        $(document).ready(function () {
            //$(".tab-content").hide();
            //$("#map-callout-tabcontent").find("#status").show();
            $(".tabs-menu a").click(function (event) {
                event.preventDefault();
                $(this).parent().addClass("active");
                $(this).parent().siblings().removeClass("active");
                var tab = $(this).attr("href");
                //$(".tab-content").not(tab).css("display", "none");                       
                //$(tab).fadeIn();
                //$(tab).show();
                $(".tab-content").hide();
                $(tab).show();
               // alert(tab);
            });
            
        }); 
        
    }
    //DisablePushpinHover(){
    //    $('.infobox-close').unbind('click');
    //    ReeferCallout.ResetCalloutState();
    //    MapCallout.ResetCalloutState();
    //}
    ResolveAddress() {
        var url = Config.ReverseGeocodeRestApi + this.props.selectedPin.GPSLatitude + "," + this.props.selectedPin.GPSLongitude + "?key=" + Config.BingMapsKey;
        //alert(url);
        //var request = RCUtils.FetchRequest(url, {
        //    method: 'GET', headers: {"Access-Control-Allow-Origin": "*", mode: 'no-cors','Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(response => response)
        //    .then(data => {
        //        debugger
        //        alert(JSON.stringify(data));
        //        $('#ancResolveaddress').parent().html(data["formattedAddress"]);
        //    });
        var divid = this.props.divid;
        $.get(url, function (data, status) {
            var responseData = JSON.parse(JSON.stringify(data));
            if (responseData.resourceSets[0].resources.length == 0)
                $('#ancResolveaddress_' + divid).parent().html("No results found.");
            else
                $('#ancResolveaddress_' + divid).parent().html(responseData.resourceSets[0].resources[0].address.formattedAddress);
        });
        
    }

    popUpGetPTIReport() {      
        var selectedPin = this.props.selectedPin; 
        if (selectedPin != undefined && selectedPin != null && selectedPin != '') {           
            if (this.props.mapName == "current")
                ReeferMapGrid.popUpGetPTIReport(selectedPin);
            else if(this.props.mapName == "status")
                ReeferMap.popUpGetPTIReport(selectedPin);
        }
    }
    
   

    public render() {
        var alarmsCss = { 'color': '#000', 'word-wrap':'break-word' };
        //var reeferCss = { 'font-weight': 'bold' };
        var preTripClass = 'nav-item hidden';
        var selectedRow = this.props.selectedPin;  

        if (this.props.mapName == "current" || this.props.mapName == "status")
            preTripClass = 'nav-item';

        var gpsLatLongCss = {};
        if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && (selectedRow.GPSLockState == null || selectedRow.GPSLockState == '' || selectedRow.GPSLockState.toUpperCase() != "LOCKED"))
            if (selectedRow.GPSLatitude != null && selectedRow.GPSLongitude != null)
                gpsLatLongCss = { 'color': 'gray', 'font-style': 'italic' };
        return (
            <div>
            <div id="tabs-container">
                    <ul className="tabs-menu nav nav-underline">
                        <li className='nav-item'><a href={"#location" + this.props.divid} className='nav-link'>Location</a></li>
                        <li className="nav-item active"><a href={"#status" + this.props.divid} className='nav-link'>Status</a></li>
                        <li className='nav-item'><a href={"#extraData" + this.props.divid} className='nav-link'>Details</a></li>
                        <li className='nav-item'><a href={"#alarm" + this.props.divid} className='nav-link'>Alarms</a></li>
                        <li className='nav-item'><a href={"#booking" + this.props.divid} className='nav-link'>Booking</a></li>
                        <li id='lipreTrip' className={preTripClass}><a href={"#preTrip" + this.props.divid} className='nav-link'>PTI</a></li>
                </ul>
                <div className="tab" id='map-callout-tabcontent'>
                    <div id={"location" + this.props.divid} className="tab-content">
                        <div>
                            <table>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Reefer ID</td><td>:</td><td>{selectedRow.ReeferID}</td></tr>
                                    <tr><td className="ra wrapword">Device Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.GeofenceName)}</td></tr>
                                    <tr><td className="ra wrapword">Server Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.ServerGeofenceName)}</td></tr>                                    
                                    <tr><td className="ra wrapword">Latitude</td><td>:</td><td style={gpsLatLongCss}>{GPSLatitudeFormatter(selectedRow)}</td></tr>
                                    <tr><td className="ra wrapword">Longitude</td><td>:</td><td style={gpsLatLongCss}>{GPSLongitudeFormatter(selectedRow)}</td></tr>
                                </tbody>
                            </table>
                                <div className="ms-3 mt-2 width320px"><a id={'ancResolveaddress_'+ this.props.divid} href='javascript:void(0)' >Resolve this address</a></div>
                        </div>
                    </div>
                    <div id={"status" + this.props.divid} className="tab-content">
                        <div>
                            <table>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Reefer ID</td><td>:</td><td>{selectedRow.ReeferID}</td></tr>
                                        <tr>
                                            <td className="ra wrapword trunc" colSpan={1} title={'Event Time ' + timeFormat}>Event Time {timeFormat}</td>
                                            <td>:</td>
                                            <td colSpan={3}>{DateTimeConverter(selectedRow.EventDTTM)}</td>
                                        </tr>
                                        <tr>
                                            <td className="ra wrapword">Event</td>
                                            <td>:</td>
                                            <td colSpan={4}><div title={EventDescriptionFormatters(selectedRow, this.props.reeferFormatters)} className="truncEvent">{EventDescriptionFormatters(selectedRow, this.props.reeferFormatters)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="ra wrapword">Setpoint Temp {tempFormat}</td>
                                            <td>:</td>
                                            <td>{TemperatureFormatter(selectedRow.SetPoint)}</td>
                                            <td className="ra wrapword">Alarm</td>
                                            <td>:</td>
                                            <td><div title={AlarmListFormatter(selectedRow.AlarmsList)} className="trunc">{AlarmListFormatter(selectedRow.AlarmsList)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="ra wrapword">Return Temp {tempFormat}</td> 
                                            <td>:</td>
                                            <td>{TemperatureFormatter(selectedRow.ReturnTemp1)}</td>
                                            {/* 
                                            <td className="ra wrapword">Reefer Attached</td>
                                            <td>:</td>
                                            <td>{YesNoFormatter(selectedRow.IsReeferPhysicallyConnected)}</td>
                                            */}
                                            <td className="ra wrapword">PWR</td>
                                            <td>:</td>
                                            <td>{pwrStateFormatter(selectedRow.DevicePowerSourceCd, selectedRow.DeviceConfig)}</td>
                                        </tr>
                                        <tr>
                                            <td className="ra wrapword">Supply Temp {tempFormat}</td>
                                            <td>:</td>
                                            <td>{TemperatureFormatter(selectedRow.SupplyTemp1)}</td>
                                            <td className="ra wrapword">RUN </td>
                                            <td>:</td>
                                            <td>{runStateFormatter(selectedRow.RunState)}</td>
                                        </tr>
                                        <tr>
                                            <td className="ra wrapword">Ambient Temp {tempFormat}</td>
                                            <td>:</td>
                                            <td>{TemperatureFormatter(selectedRow.AmbientTemp)}</td>
                                            <td className="ra wrapword">Device Bat. (V)</td>
                                            <td>:</td>
                                            <td>{BattVoltageFormatter(selectedRow.BatteryVoltage)}</td>
                                        </tr>
                                        <tr>
                                            <td className="ra wrapword">Controller Mode</td>
                                            <td>:</td>
                                            <td>{StringTypeFormatter(selectedRow.ControlModeID)}</td>
                                        </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id={"extraData" + this.props.divid} className="tab-content">
                        <div>
                            <table className='width-95'>
                                    <tbody>
                                        <tr><td className="ra wrapword">Return Temp 2 {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.ReturnTemp2)}</td>  <td className="ra wrapword">Humidity Setpoint</td><td>:</td><td>{HumiditySetpointFormatter(selectedRow.HumiditySetpoint)}</td> </tr>
                                        <tr><td className="ra wrapword"> Supply Temp 2 {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.SupplyTemp2)}</td> <td className="ra wrapword">O2 Setpoint</td><td>:</td><td>{SensorDataFormatter(selectedRow.O2Setpoint)}</td> </tr>
                                        <tr><td className="ra wrapword">Suction Temp {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.CompressorSuctionTemp)}</td> <td className="ra wrapword">CO2 Setpoint</td><td>:</td><td>{SensorDataFormatter(selectedRow.CO2Setpoint)}</td> </tr>
                                        <tr> <td className="ra wrapword">Suction Press</td><td>:</td><td>{SensorDataFormatter(selectedRow.CompositeSuctionPressure)}</td>   <td className="ra wrapword">USDA 1 {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.USDA1Temp)}</td>       </tr>
                                        <tr><td className="ra wrapword">Discharge Press</td><td>:</td><td>{SensorDataFormatter(selectedRow.DischargePressure)}</td>    <td className="ra wrapword">USDA 2 {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.USDA2Temp)}</td> </tr>
                                        <tr><td className="ra wrapword">Condenser Press</td><td>:</td><td>{sensorDataPCondFormatter(selectedRow.ReeferOEMTypeCd, selectedRow.CondenserPressure)}</td>  <td className="ra wrapword">USDA 3 {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.USDA3Temp)}</td>   </tr>
                                        <tr>  <td className="ra wrapword">3-Phase Current</td><td>:</td><td className="trunc" title={Current3PhaseFormatter(selectedRow.ThreePhaseCurrent)}>{Current3PhaseFormatter(selectedRow.ThreePhaseCurrent)}</td>  <td className="ra wrapword">USDA 4/Cargo {tempFormat}</td><td>:</td><td>{TemperatureFormatter(selectedRow.Cargo4Temp)}</td> </tr>
                                        <tr> <td className="ra wrapword">Frequency</td><td>:</td><td>{LineFrequencyFormatter(selectedRow.LineFrequency, selectedRow.LineFrequencyQualifier, selectedRow.ReeferOEMTypeCd, selectedRow.ControllerTypeCd)}</td>  <td className="ra wrapword">Fresh Air Ex</td><td>:</td><td>{selectedRow.VentPositionSensorCMH}</td> </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                        <div id={"alarm" + this.props.divid} className="tab-content">
                            <div><div style={alarmsCss} dangerouslySetInnerHTML={{ __html: AlarmDescriptionFormatter(selectedRow.AlarmsList, this.props.reeferFormatters.AlarmMasterList, selectedRow.DeviceType)}}></div></div>
                    </div>
                    <div id={"booking" + this.props.divid} className="tab-content">
                        <div>
                            <table>
                                <tbody>
                                    <tr><td className="ra wrapword">Booking #</td><td>:</td><td>{StringTypeFormatter(selectedRow.BookingNumber)}</td></tr>
                                        <tr><td className="ra wrapword">BK temp {tempFormat}</td><td>:</td><td>{TemperatureFormatterForBooking(selectedRow.TemperatureUnit)}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id={"preTrip" + this.props.divid} className="tab-content">
                        <div>
                            <table>
                                <tbody>                                    
                                        <tr><td className="ra wrapword trunc" colSpan={1} title={'PTI Time ' + timeFormat}>PTI Time {timeFormat}</td><td>:</td><td colSpan={3}>{DateTimeConverter(selectedRow.PTRDateTime)}</td></tr>
                          
                                        <tr><td className="ra wrapword">PTI Report</td><td>:</td><td><div>{(selectedRow.ReeferID != null && ((selectedRow.ReeferOEMTypeCd != null && selectedRow.ReeferOEMTypeCd.trim() != 'T') || (selectedRow.OEMModel == 'MP3000A' || selectedRow.OEMModel == 'MP3000'))) ? <a id={'PreTripReport_' + this.props.divid} href='javascript:void(0)'>Show Pre-Trip Results</a> : '-NA-'}</div></td></tr>
                                        <tr><td className="ra wrapword">PTI Result</td><td>:</td><td>{(selectedRow.PTResult != null && selectedRow.PTResult.trim() != '-NA-' && selectedRow.PTResult.trim() != '') ? <img title={selectedRow.PTResult.trim() == "OK" ? "Passed" : selectedRow.PTResult.trim() == "NG" ? "Failed" : selectedRow.PTResult.trim()} className='Rssiformatter' src={preTripFormatter(selectedRow.PTResult)}></img> : '-NA-'}</td></tr>
                                     
                                </tbody>
                            </table>
                                    
                        </div>
                    </div>
                </div>
                </div>
                </div>
        );
    }
}

export class GensetPinInfoboxDescription extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        tempFormat = GetTempColumnFormatter();
        timeFormat = GetTimeZoneFormatter().toString();
    }
    componentDidMount() {
        $('#ancResolveaddress_' + this.props.divid).click(this.ResolveGensetAddress.bind(this));
        $("#status" + this.props.divid).show();
        $(document).ready(function () {
            //$(".tab-content").hide();
            //$("#map-callout-tabcontent").find("#status").show();
            $(".tabs-menu a").click(function (event) {
                event.preventDefault();
                $(this).parent().addClass("active");
                $(this).parent().siblings().removeClass("active");
                var tab = $(this).attr("href");
                //$(".tab-content").not(tab).css("display", "none");                       
                //$(tab).fadeIn();
                //$(tab).show();
                $(".tab-content").hide();
                $(tab).show();
                // alert(tab);
            });
        });
    }
    ResolveGensetAddress() {
        var url = Config.ReverseGeocodeRestApi + this.props.selectedPin.Latitude + "," + this.props.selectedPin.Longitude + "?key=" + Config.BingMapsKey;
        //alert(url);
        //var request = RCUtils.FetchRequest(url, {
        //    method: 'GET', headers: {"Access-Control-Allow-Origin": "*", mode: 'no-cors','Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(response => response)
        //    .then(data => {
        //        debugger
        //        alert(JSON.stringify(data));
        //        $('#ancResolveaddress').parent().html(data["formattedAddress"]);
        //    });
        var divid = this.props.divid;
        $.get(url, function (data, status) {
            var responseData = JSON.parse(JSON.stringify(data));
            if (responseData.resourceSets[0].resources.length == 0)
                $('#ancResolveaddress_' + divid).parent().html("No results found.");
            else
                $('#ancResolveaddress_' + divid).parent().html(responseData.resourceSets[0].resources[0].address.formattedAddress);
        });

    }
    public render() {
        var alarmsCss = { 'color': '#000', 'word-wrap': 'break-word' };
        //var reeferCss = { 'font-weight': 'bold' };
        var selectedRow = this.props.selectedPin;

        var gpsLatLongCss = {};
        if (selectedRow.Latitude != 0 && selectedRow.Longitude != 0 && (selectedRow.GPSLockState == null || selectedRow.GPSLockState == '' || selectedRow.GPSLockState.toUpperCase() != "LOCKED"))
            if (selectedRow.Latitude != null && selectedRow.Longitude != null)
                gpsLatLongCss = { 'color': 'gray', 'font-style': 'italic' };
        return (
            <div id="tabs-container">
                <ul className="tabs-menu nav nav-underline GensetCallout">
                    <li className='nav-item'><a href={"#location" + this.props.divid} className='nav-link'>Location</a></li>
                    <li className='nav-item active'><a href={"#status" + this.props.divid} className='nav-link'>Status</a></li>
                             
                </ul>
                <div className="tab" id='map-callout-tabcontent'>
                    <div id={"location" + this.props.divid} className="tab-content">
                        <div className='ml-15'>
                            <table className='mb-3 mt-2'>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Genset ID</td><td>:</td><td>{selectedRow.AssetNumber}</td></tr>
                                    <tr><td className="ra wrapword">Device Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.FenceName)}</td></tr>
                                    <tr><td className="ra wrapword">Server Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.BackendGeofenceName)}</td></tr>                                    
                                    <tr><td className="ra wrapword">Latitude</td><td>:</td><td style={gpsLatLongCss}>{GensetLatitudeFormatter(selectedRow)}</td></tr>
                                    <tr><td className="ra wrapword">Longitude</td><td>:</td><td style={gpsLatLongCss}>{GensetLongitudeFormatter(selectedRow)}</td></tr>

                                </tbody>
                            </table>
                            
                            {/* // RCNG 1257 <div className="ms-3 mt-2 width320px"><a id={'ancResolveaddress_' + this.props.divid} href='javascript:void(0)' >Resolve this address</a></div>*/

                                selectedRow.Address != '' && selectedRow.Address != null ? <div className="ms-4 width300px">{selectedRow.Address}</div> :
                                    <div className="ms-4 width300px"><a id={'ancResolveaddress_' + this.props.divid} href='javascript:void(0)' >Resolve this address</a></div>
                            }
                        </div>
                    </div>
                    <div id={"status" + this.props.divid} className="tab-content">
                        <div>
                            <table className='w-100'>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Genset ID</td><td>:</td><td>{selectedRow.AssetNumber}</td></tr>                                    
                                    <tr><td className="ra wrapword trunc" colSpan={1} title={'Event Time ' + timeFormat}>Event Time {timeFormat}</td><td>:</td><td colSpan={3}>{DateTimeConverter(selectedRow.EventDTTM)}</td></tr>
                                    <tr><td className="ra wrapword">Event</td><td>:</td><td colSpan={4} className="truncEvent" title={StringTypeFormatter(selectedRow.EventDescription)}>{StringTypeFormatter(selectedRow.EventDescription)}</td></tr>                                    
                                    <tr><td className="ra wrapword">Switch</td><td>:</td><td>{gensetSwitchFormatter(selectedRow.IgnitionOn)}</td><td className="ra wrapword">Device Bat. (V)</td><td>:</td><td>{BattVoltageFormatter(selectedRow.BattVoltage)}</td></tr>
                                    <tr><td className="ra wrapword">Engine</td><td>:</td><td>{gensetRunningFormatter(selectedRow.HasOilPressureSwitch, selectedRow.GensetRunning, selectedRow.OEMTypeCD)}</td><td className="ra wrapword">Genset Bat. (V)</td><td>:</td><td>{BattVoltageFormatter(selectedRow.ExtBattVoltage)}</td></tr>
                                    <tr><td className="ra wrapword">Alarm</td><td>:</td><td><div title={AlarmListFormatter(selectedRow.AlarmsList)} className="trunc">{AlarmListFormatter(selectedRow.AlarmsList)}</div></td>
                                        <td className="ra wrapword">Fuel (gal.)</td><td>:</td><td>{fillLevelGalTrace(selectedRow.FuelLevel, selectedRow.FuelLevelQualifier, selectedRow.FuelLevelQualifierDesc, selectedRow.HasFuelSensor)}</td></tr>
                                    <tr><td className="ra wrapword">Reefer ID</td><td>:</td><td>{'-NA-'}</td>
                                        <td className="ra wrapword">Fuel Level</td>
                                        <td>:</td>
                                        <td className="text-align-left">
                                            {(
                                                (selectedRow.HasFuelSensor != null && selectedRow.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") ?
                                                (
                                                    (selectedRow.FuelLevelQualifier != null && ((selectedRow.FuelLevelQualifier == 'A') ||
                                                (selectedRow.FuelLevelQualifier == 'P')) && selectedRow.FuelLevelTierNumber != null)
                                                ?
                                                <img className='Rssiformatter FuelLevelRectImg' src={fillLevelTrace(selectedRow)}></img>
                                                :
                                                        (fillLevelTrace(selectedRow) == "FRU" ?
                                                                <div className="variousClass" title='Fuel Reading Unavailable'>Fuel Reading Unavailable</div>  :
                                                         fillLevelTrace(selectedRow) == "FSE" ?
                                                                    <div className="variousClass" title='Sensor Error'>Sensor Error</div> :
                                                                    fillLevelTrace(selectedRow))) : <span>No Sensor</span>)
                                            }</td>
                                    </tr>
                                    <tr><td className="ra wrapword">Reefer State </td><td>:</td>
                                        <td className="trunc" title={StringTypeFormatter(selectedRow.ReeferStateDsc)}>{StringTypeFormatter(selectedRow.ReeferStateDsc)}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>                    
                    <div id={"alarm" + this.props.divid} className="tab-content">
                        <div><div style={alarmsCss}>{AlarmListFormatter(selectedRow.AlarmsList)}</div></div>
                    </div>                 
                </div>
            </div>

        );
    }
}


export class DryPinInfoboxDescription extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        tempFormat = GetTempColumnFormatter();
        timeFormat = GetTimeZoneFormatter().toString();
    }
    componentDidMount() {
        $('#ancResolveaddress_' + this.props.divid).click(this.ResolveDryAddress.bind(this));
        $("#status" + this.props.divid).show();
        $(document).ready(function () {
            //$(".tab-content").hide();
            //$("#map-callout-tabcontent").find("#status").show();
            $(".tabs-menu a").click(function (event) {
                event.preventDefault();
                $(this).parent().addClass("active");
                $(this).parent().siblings().removeClass("active");
                var tab = $(this).attr("href");
                //$(".tab-content").not(tab).css("display", "none");                       
                //$(tab).fadeIn();
                //$(tab).show();
                $(".tab-content").hide();
                $(tab).show();
                // alert(tab);
            });
        });
    }
    ResolveDryAddress() {
        var url = Config.ReverseGeocodeRestApi + this.props.selectedPin.Latitude + "," + this.props.selectedPin.Longitude + "?key=" + Config.BingMapsKey;
        //alert(url);
        //var request = RCUtils.FetchRequest(url, {
        //    method: 'GET', headers: {"Access-Control-Allow-Origin": "*", mode: 'no-cors','Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(response => response)
        //    .then(data => {
        //        debugger
        //        alert(JSON.stringify(data));
        //        $('#ancResolveaddress').parent().html(data["formattedAddress"]);
        //    });
        var divid = this.props.divid;
        $.get(url, function (data, status) {
            var responseData = JSON.parse(JSON.stringify(data));
            if (responseData.resourceSets[0].resources.length == 0)
                $('#ancResolveaddress_' + divid).parent().html("No results found.");
            else
                $('#ancResolveaddress_' + divid).parent().html(responseData.resourceSets[0].resources[0].address.formattedAddress);
        });

    }
    public render() {
        var alarmsCss = { 'color': '#000', 'word-wrap': 'break-word' };
        //var reeferCss = { 'font-weight': 'bold' };
        var selectedRow = this.props.selectedPin;

        var gpsLatLongCss = {};
        if (selectedRow.Latitude != 0 && selectedRow.Longitude != 0 && (selectedRow.GPSLockState == null || selectedRow.GPSLockState == '' || selectedRow.GPSLockState.toUpperCase() != "LOCKED"))
            if (selectedRow.Latitude != null && selectedRow.Longitude != null)
                gpsLatLongCss = { 'color': 'gray', 'font-style': 'italic' };
        return (
            <div id="tabs-container">
                <ul className="tabs-menu nav nav-underline GensetCallout">
                    <li className='nav-item'><a href={"#location" + this.props.divid} className='nav-link'>Location</a></li>
                    <li className="nav-item active"><a href={"#status" + this.props.divid} className='nav-link' >Status</a></li>
                </ul>
                <div className="tab" id='map-callout-tabcontent'>
                    <div id={"location" + this.props.divid} className="tab-content">
                        <div className='ml-15'>
                            <table className='mb-3 mt-2'>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Dry Container ID</td><td>:</td><td>{selectedRow.AssetNumber}</td></tr>
                                    <tr><td className="ra wrapword">Device Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.FenceName)}</td></tr>     
                                    <tr><td className="ra wrapword">Server Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.BackendGeofenceName)}</td></tr>
                                    <tr><td className="ra wrapword">Latitude</td><td>:</td><td style={gpsLatLongCss}>{GensetLatitudeFormatter(selectedRow)}</td></tr>
                                    <tr><td className="ra wrapword">Longitude</td><td>:</td><td style={gpsLatLongCss}>{GensetLongitudeFormatter(selectedRow)}</td></tr>
                                    <tr><td className="ra wrapword">Location accuracy (m)</td><td>:</td><td>{StringTypeFormatter(selectedRow.PositionAccuracy)}</td></tr>                                    
                                </tbody>
                            </table>
                            {/* // RCNG 1232 <div className="text-align-left wrapword pl-35"><a id={'ancResolveaddress_' + this.props.divid} href='javascript:void(0)' >Resolve this address</a></div>*/
                            
                                selectedRow.Address != '' && selectedRow.Address != null ? <div className="ms-4 width320px">{selectedRow.Address}</div> :
                                    <div className="ms-4 width320px"><a id={'ancResolveaddress_' + this.props.divid} href='javascript:void(0)' >Resolve this address</a></div>
                            }
                        </div>
                    </div>
                    <div id={"status" + this.props.divid} className="tab-content">
                        <div className='ml-15'>
                            <table className='mt-2'>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Dry Container ID</td><td>:</td><td>{selectedRow.AssetNumber}</td></tr>
                                    <tr><td className="ra wrapword trunc" colSpan={1} title={'Event Time ' + timeFormat}>Event Time {timeFormat}</td><td>:</td><td colSpan={3}>{DateTimeConverter(selectedRow.EventDTTM)}</td></tr>
                                    <tr><td className="ra wrapword valignTop">Event</td><td className="valignTop">:</td><td><div title={StringTypeFormatter(selectedRow.EventDescription)}>{StringTypeFormatter(selectedRow.EventDescription)}</div></td></tr> 
                                    <tr><td className="ra wrapword">Device Bat. (V)</td><td>:</td><td>{BattVoltageFormatter(selectedRow.BattVoltage)}</td></tr>
                                    <tr><td className="ra wrapword">Door</td><td>:</td><td>{DrydoorFormatter(selectedRow.Door1Open, selectedRow.HasDoorSensor)}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id={"alarm" + this.props.divid} className="tab-content">
                        <div><div style={alarmsCss}>{AlarmListFormatter(selectedRow.AlarmsList)}</div></div>
                    </div>
                </div>
            </div>

        );
    }
}

export class ChassisPinInfoboxDescription extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        tempFormat = GetTempColumnFormatter();
        timeFormat = GetTimeZoneFormatter().toString();
    }
    componentDidMount() {
        $('#ancResolveaddress_' + this.props.divid).click(this.ResolveChassisAddress.bind(this));
        $("#status" + this.props.divid).show();
        $(document).ready(function () {
            //$(".tab-content").hide();
            //$("#map-callout-tabcontent").find("#status").show();
            $(".tabs-menu a").click(function (event) {
                event.preventDefault();
                $(this).parent().addClass("active");
                $(this).parent().siblings().removeClass("active");
                var tab = $(this).attr("href");
                //$(".tab-content").not(tab).css("display", "none");                       
                //$(tab).fadeIn();
                //$(tab).show();
                $(".tab-content").hide();
                $(tab).show();
                // alert(tab);
            });
        });
    }
    ResolveChassisAddress() {
        var url = Config.ReverseGeocodeRestApi + this.props.selectedPin.Latitude + "," + this.props.selectedPin.Longitude + "?key=" + Config.BingMapsKey;
        //alert(url);
        //var request = RCUtils.FetchRequest(url, {
        //    method: 'GET', headers: {"Access-Control-Allow-Origin": "*", mode: 'no-cors','Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(response => response)
        //    .then(data => {
        //        debugger
        //        alert(JSON.stringify(data));
        //        $('#ancResolveaddress').parent().html(data["formattedAddress"]);
        //    });
        var divid = this.props.divid;
        $.get(url, function (data, status) {
            var responseData = JSON.parse(JSON.stringify(data));
            if (responseData.resourceSets[0].resources.length == 0)
                $('#ancResolveaddress_' + divid).parent().html("No results found.");
            else
                $('#ancResolveaddress_' + divid).parent().html(responseData.resourceSets[0].resources[0].address.formattedAddress);
        });

    }
    public render() {
        var alarmsCss = { 'color': '#000', 'word-wrap': 'break-word' };
        //var reeferCss = { 'font-weight': 'bold' };
        var selectedRow = this.props.selectedPin;

        var gpsLatLongCss = {};
        if (selectedRow.Latitude != 0 && selectedRow.Longitude != 0 && (selectedRow.GPSLockState == null || selectedRow.GPSLockState == '' || selectedRow.GPSLockState.toUpperCase() != "LOCKED"))
            if (selectedRow.Latitude != null && selectedRow.Longitude != null)
                gpsLatLongCss = { 'color': 'gray', 'font-style': 'italic' };
        return (
            <div id="tabs-container">
                <ul className="tabs-menu nav nav-underline GensetCallout">
                    <li className='nav-item'><a href={"#location" + this.props.divid} className='nav-link'>Location</a></li>
                    <li className="nav-item active"><a href={"#status" + this.props.divid} className='nav-link'>Status</a></li>
                </ul>
                <div className="tab" id='map-callout-tabcontent'>
                    <div id={"location" + this.props.divid} className="tab-content">
                        <div>
                            <table className='mb-3'>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Chassis ID</td><td>:</td><td>{selectedRow.AssetNumber}</td></tr>
                                    <tr><td className="ra wrapword">Device Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.FenceName)}</td></tr>
                                    <tr><td className="ra wrapword">Server Fence</td><td>:</td><td>{StringTypeFormatter(selectedRow.BackendGeofenceName)}</td></tr>
                                    <tr><td className="ra wrapword">Latitude</td><td>:</td><td style={gpsLatLongCss}>{GensetLatitudeFormatter(selectedRow)}</td></tr>
                                    <tr><td className="ra wrapword">Longitude</td><td>:</td><td style={gpsLatLongCss}>{GensetLongitudeFormatter(selectedRow)}</td></tr>

                                </tbody>
                            </table>
                            <div className="ms-4 mt-2 width320px"><a id={'ancResolveaddress_' + this.props.divid} href='javascript:void(0)' >Resolve this address</a></div>
                        </div>
                    </div>
                    <div id={"status" + this.props.divid} className="tab-content">
                        <div>
                            <table>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Chassis ID</td><td>:</td><td>{selectedRow.AssetNumber}</td></tr>
                                    <tr><td className="ra wrapword trunc" colSpan={1} title={'Event Time ' + timeFormat}>Event Time {timeFormat}</td><td>:</td><td colSpan={3}>{DateTimeConverter(selectedRow.EventDTTM)}</td></tr>
                                    <tr><td className="ra wrapword">Event</td><td>:</td><td colSpan={4}><div title={StringTypeFormatter(selectedRow.EventDescription)} className="truncEvent">{StringTypeFormatter(selectedRow.EventDescription)}</div></td></tr>
                                    <tr><td className="ra wrapword">RUN</td><td>:</td><td>{'-NA-'}</td><td className="ra wrapword">Device Bat. (V)</td><td>:</td><td>{BattVoltageFormatter(selectedRow.BattVoltage)}</td></tr>
                                    <tr><td className="ra wrapword">Reefer ID</td><td>:</td><td>{'-NA-'}</td><td className="ra wrapword">Vehicle Bat. (V)</td><td>:</td><td>{selectedRow.DeviceBattery}</td></tr> 
                                    <tr><td className="ra wrapword">PWR</td><td>:</td><td>{pwrStateFormatterChassis(selectedRow.PWR)}</td><td className="ra wrapword">Tire Pressure</td><td>:</td><td>{FloatTypeFormatter(selectedRow.TyrePressure)}</td></tr>
                                    <tr><td className="ra wrapword">Loaded</td><td>:</td><td>{LoadedFormatter(selectedRow.Loaded)}</td><td className="ra wrapword">Brake Signal</td><td>:</td><td>{BrakeSignalFormatter(selectedRow.BreakSignal)}</td></tr>
                                    <tr><td className="ra wrapword">BATT</td><td>:</td><td>{ChassisBatteryStatusFormatter(selectedRow.ChassisBatteryStatus)}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>                    
                </div>
            </div>

        );
    }
}

export class PinInfoboxNoLocation extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

    }
    componentDidMount() {
        $('#btnClosePopup').click(this.ClosePopup.bind(this));
    }
    ClosePopup() {
        $("#infobox_" + this.props.divid).hide();
    }
    public render() {
        var style = { 'min-height': '50px', 'width': '240px' };
        var disable = { 'display': 'none' };
        return (
            <div id={"infobox_" + this.props.divid} className="panel panel-primary" style={style}>
                <div style={disable} id="infoboxTitle" className="panel-heading">Alert</div>
                <div style={disable}><button type="button" id="btnClosePopup" className="close" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>
                <div id="infoboxDescription" className="panel-body"> -No Location- </div> </div>
            )        
    }
}

export class PinInfoboxFenceLocation extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        timeFormat = GetTimeZoneFormatter().toString();
    }

    componentDidMount() {
        $('#ancFindAssets_' + this.props.divid).click(this.findAssetsAtThisLocation.bind(this));
    }

    findAssetsAtThisLocation() {
        var fenceTag = this.props.selectedPin.Tag;

        if (fenceTag != null && fenceTag != "" && fenceTag != undefined) {
            AdvanceSearch.FindAssetByFenceLocation(fenceTag);
        }
    }
    
    public render() {
        var selectedRow = this.props.selectedPin;
        //var reeferCss = { 'font-weight': 'bold' };

        return (
            <div>
                <div id="tabs-container">
                    <div id={"fence" + this.props.divid} className="tab-content">
                        <div className='mt-1 ms-3'>
                            <table className='map-font'>
                                <tbody>
                                    <tr className="fw-semibold"><td className="ra wrapword">Fence ID</td><td className='px-1'>:</td><td title={StringTypeFormatter(selectedRow.Tag)} className="ellipsis">{selectedRow.Tag}</td></tr>
                                    <tr><td className="ra wrapword">Fence Name</td><td className='px-1'>:</td><td title={StringTypeFormatter(selectedRow.Name)} className="ellipsis">{StringTypeFormatter(selectedRow.Name)}</td></tr>
                                    <tr><td className="ra wrapword">Address</td><td className='px-1'>:</td><td title={StringTypeFormatter(selectedRow.Address)} className="ellipsis">{StringTypeFormatter(selectedRow.Address)}</td></tr>
                                    <tr><td className="ra wrapword">Fence Type</td><td className='px-1'>:</td><td>{FenceTypeFormatter(selectedRow.GeofenceCategoryCd)}</td></tr>
                                    <tr><td className="ra wrapword">Last Updated Time  {timeFormat}</td><td className='px-1'>:</td><td>{DateTimeConverter(selectedRow.EffectiveDTTM)}</td></tr>
                                </tbody>
                            </table>
                            {
                                this.props.source == "Dashboard" ?
                                    <div className="geofenceMaptext"><a id={'ancFindAssets_' + this.props.divid} href='javascript:void(0)' >Find Assets at this Location</a></div>
                                    : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        )        
    }
}

function ReeferPowerSource(rcdPowerSourceCd) {
    var rcdPwrSource = '-NA-';
    if (rcdPowerSourceCd != null && rcdPowerSourceCd != undefined && rcdPowerSourceCd != '') {
        switch (rcdPowerSourceCd.toString().toUpperCase().trim()) {
            case "A":
                rcdPwrSource = "AC";
                break;
            case "B":
                rcdPwrSource = "Battery";
                break;
        }
    }
    return rcdPwrSource;
}
function FenceTypeFormatter(params) {
    if (params != null && params != undefined && params != '') {
        if (params.toString().trim() == "D")
            return "Device Fence";
        else if (params.toString().trim() == "R")
            return "Region Fence";
        else if (params.toString().trim() == "B")
            return "Server Fence";
        else
            return '-NA-';
    }
    else
        return '-NA-';
}

function StringTypeFormatter(params) {
    if (params != null && params != undefined && params != '') {
        return params;
    }
    else
        return '-NA-';
}
function gensetSwitchFormatter(params) {
    if (params != null && params != undefined) {
        if (params.toString().toUpperCase().trim() == "TRUE")
            return "On";
        else
            return "Off";
    }
    else
        return '-NA-';
}
function DateTimeConverter(dttmValue) {
    if (dttmValue == "" || dttmValue == null) {
        return '-NA-';
    }
    else {
        var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
        var eventdttm = new Date(dttmValue);
        var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
        return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');

    }
}
function YearFromDateTimeConverter(dttmValue) {
    if (dttmValue == "" || dttmValue == null) {
        return '-NA-';
    }
    else {
        var eventdttm = new Date(dttmValue);
        return eventdttm.getFullYear();

    }
}
function TemperatureFormatter(params) {
    //var tempRoundingValue = "1";
    var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
    var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

    if (params != null && params != undefined) {
        if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
            return "OOR";
        else {
            var tempVal = parseFloat(params);

            if (tempUnitCd.toUpperCase() == "F") {
                tempVal = ((tempVal * 9) / 5) + 32;

                var param = parseFloat(tempVal.toString());
               // return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                    param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
            }
            else
                //return parseFloat(params.toFixed(parseInt(tempRoundingValue)));
            return tempRoundingValue > 0 ? params.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                params.toFixed(parseInt(tempRoundingValue)) : params.toFixed(1);
        }
    }
    else
        return '-NA-';
}
function TemperatureFormatterForBooking(params) {
    //var tempRoundingValue = "1";
    var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
    var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
    var BookedTemperature = null;
    var TempUnit = null;
    if (params != null) {
        var strlstValues = params.split('@');
        BookedTemperature = strlstValues[0];
        TempUnit = strlstValues[1];
        if (TempUnit.toUpperCase() == "N")
            return "Non-Running";
        else if (TempUnit.toUpperCase() != tempUnitCd.toUpperCase()) {
            if ("F" == tempUnitCd.toUpperCase()) {
                var tempValue = parseFloat(BookedTemperature.toString());
                tempValue = ((tempValue * 9) / 5) + 32;
                var param = parseFloat(tempValue.toString());
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempValue = parseFloat(BookedTemperature.toString());
                tempValue = (tempValue - 32) * 5 / 9;
                var param = parseFloat(tempValue.toString());
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
        return parseFloat(parseFloat(BookedTemperature.toString()).toFixed(parseInt(tempRoundingValue)));
    }
    else
        return '-NA-';
}
//function GPSLongitudeFormatter(params) {
//    if (params != null && params != undefined && params != '') {
//        if (params.GPSLongitude != null) {
//            //params.GPSLongitude = '<span style="color: gray;font-style: italic;" > ' + params.GPSLongitude + '</span>';

//            return params.GPSLongitude;
//        }
//        else
//            return '-NA-';
//    }

//}
//function GensetLongitudeFormatter(params) {
//    if (params != null && params != undefined && params != '') {
//        if (params.Longitude != null) {
//            //params.GPSLongitude = '<span style="color: gray;font-style: italic;" > ' + params.GPSLongitude + '</span>';

//            return params.Longitude;
//        }
//        else
//            return '-NA-';
//    }

//}
//function GPSLatitudeFormatter(params) {
//    if (params != null && params != undefined && params != '') {
//        if (params.GPSLatitude != null) {
//            //params.GPSLatitude = '<span style="color: gray;font-style: italic;" > ' + params.GPSLatitude + '</span>';

//            return params.GPSLatitude;
//        }
//        else
//            return '-NA-';
//    }

//}
//function GensetLatitudeFormatter(params) {
//    if (params != null && params != undefined && params != '') {
//        if (params.Latitude != null) {
//            //params.GPSLatitude = '<span style="color: gray;font-style: italic;" > ' + params.GPSLatitude + '</span>';

//            return params.Latitude;
//        }
//        else
//            return '-NA-';
//    }

//}

function GensetLatitudeFormatter(params) {
    if (params != null && params != undefined) {
        var tempRoundingValue = "6";
        if (params.Latitude != null && params.Latitude != undefined && params.Latitude.toString() != "") {
            var lat = parseFloat(params.Latitude.toString());
            var param = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString());
            return param;
        }
        else
            return "-NA-";
    }
    else
        return "-NA-";
}

function GensetLongitudeFormatter(params) {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";
            if (params.Longitude != null && params.Longitude != undefined && params.Longitude.toString() != "") {
                var longitute = parseFloat(params.Longitude.toString());
                var param = parseFloat(longitute.toFixed(parseInt(tempRoundingValue)).toString());
                return param;
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
}


function GPSLatitudeFormatter(params) {
    if (params != null && params != undefined) {
        var tempRoundingValue = "6";
        if (params.GPSLatitude != null && params.GPSLatitude != undefined && params.GPSLatitude.toString() != "") {
            var lat = parseFloat(params.GPSLatitude.toString());
            var param = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString());
            return param;
        }
        else
            return "-NA-";
    }
    else
        return "-NA-";
}

function GPSLongitudeFormatter(params) {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";
            if (params.GPSLongitude != null && params.GPSLongitude != undefined && params.GPSLongitude.toString() != "") {
                var longitute = parseFloat(params.GPSLongitude.toString());
                var param = parseFloat(longitute.toFixed(parseInt(tempRoundingValue)).toString());
                return param;
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    }


function YesNoFormatter(params) {
    if (params != null && params != undefined && params.toString() != '') {
        if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE") {
            return "No";
        }
        else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE") {
            return "Yes";
        }
        else {
            return "-NA-";
        }
    }
    return "-NA-";
}
function gensetRunningFormatter(HasOilPressureSwitch, GensetRunning,OEMTypeCD) {
    if (HasOilPressureSwitch != null && GensetRunning != null) {
        if (HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
            if (OEMTypeCD != null && OEMTypeCD.toString().toUpperCase().trim() == "C") {
                return "-NA-";
            }

            if (GensetRunning.toString().toUpperCase().trim() == "0" || GensetRunning.toString().toUpperCase().trim() == "FALSE") {
                return "Off";//"No";
            }
            else if (GensetRunning.toString().toUpperCase().trim() == "1" || GensetRunning.toString().toUpperCase().trim() == "TRUE") {
                return "On";//"Yes";
            }
            else
                return "-NA-";
        }
        else
            return '-NA-';
    }
    else
        return '-NA-';
}
function runStateFormatter(RunState) {
    if (RunState != null && RunState != undefined) {
        if ((RunState.toString().toUpperCase().trim()) == 'I')
            return "Running";
        else if ((RunState.toString().toUpperCase().trim()) == 'S')
            return "Standby";
        else if ((RunState.toString().toUpperCase().trim()) == 'X')
            return "Faulty";
        else if ((RunState.toString().toUpperCase().trim()) == 'O')
            return "Offline";
        else
            return '';
    }

    return '';
}
function doorFormatter(Door1Open, HasDoorSensor) {
        if (HasDoorSensor != null && HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
            if (Door1Open != null) {
                if (Door1Open.toString().toUpperCase().trim() == "TRUE")
                    return "Open";
                else
                    return "Closed";
            }
            else
                return "Unknown";
        }
        else
            return "No Sensor";
}
function DrydoorFormatter(Door1Open, HasDoorSensor) {
    if (HasDoorSensor != null && HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
        if (Door1Open != null) {
            switch (Door1Open.toString().toUpperCase().trim()) {
                case "OPN":
                    return "Open";
                case "CLS":
                    return "Closed";
                case "DIS":
                    return "Sensor Error"
                case "UNP":
                    return "No Sensor";
                case "UNK":
                    return "-NA-";
            }
        }
        else
            return "-NA-";
    }
    else
        return "No Sensor";
}
function FenceStatusFormatter(params) {
    if (params != null && params != undefined && params.toString() != '') {
        if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE") {
            return "OUT";
        }
        else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE") {
            return "IN";
        }
        else {
            return "-NA-";
        }
    }
    return "-NA-";
}
function AlarmListFormatter(params) {
    // debugger;
    if (params != null && params != undefined && params != '') {
        if (params.toString().endsWith(",")) {
            params = params.slice(0, -1);
        }
        return params;
    }

    else return "";
}
function EventDescriptionFormatters(params, formatters) {
    var eventDesc = '-NA-';
    var customerSpecificEventList = formatters.CustomerSpecificEventList;
    var eventMasterList = formatters.EventMasterList;
    if (params != null && params != undefined && params != "null") {
        var reeferOEMTypeCd = params.ReeferOEMTypeCd == null ? "" : params.ReeferOEMTypeCd; // WI 26532
        if (params.EventMasterID != null && params.EventMasterID != "" && params.EventMasterID != "null") {
            var eventlist = lodashfilter(customerSpecificEventList, function (item) {
                return item.EventMasterID === params.EventMasterID;
            });
            var custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
            var custSpecificEventList = lodashfilter(eventlist, function (item) {
                return item.CustomerID === custId;
            });
            var finalcustSpecificEventList = lodashfilter(custSpecificEventList, function (item) {
                return item.OEMType === reeferOEMTypeCd.toString().trim();// WI 26532
            });
            if (finalcustSpecificEventList != null && finalcustSpecificEventList.length) {
                eventDesc = finalcustSpecificEventList.length > 0 ? finalcustSpecificEventList[0].EventDescription.toString() : "";
            }
            else {
                var eventDescription = lodashfilter(eventMasterList, function (item) {
                    return item.EventMasterID === params.EventMasterID;
                });
                if (eventDescription.length > 0 && eventDescription != null) {
                   if (eventDescription[0].OverrideEventDesc != null && eventDescription[0].OverrideEventDesc == true) {
                        if (params.OEParams != null && params.OEParams != "" && params.OEParams.length > 0) {
                            var OperationalEventParams = params.OEParams.trimEnd();
                            if (OperationalEventParams != null && OperationalEventParams != "") {
                                return eventDescription[0].EventDescription + OperationalEventParams; //WI26438 Operational event not shown properly in Status Grid
                            }
                        }
                    }
                    else {
                        if (eventDescription[0].EventCd == "ATP" || eventDescription[0].EventCd == "UTP") {
                            if (params.CustCd3P != null && params.CustCd3P != "" && params.CustName3P != null && params.CustName3P != "") {
                                return eventDesc = eventDescription[0].EventDescription + params.CustCd3P + " (" + params.CustName3P + ")";
                            }
                        }

                    }
                    return eventDesc = eventDescription[0].EventDescription;
                }

            }
        }
        return eventDesc;
    }

    return eventDesc;
}
function fillLevelGalTrace(FuelLevel, FuelLevelQualifier, FuelLevelQualifierDesc, HasFuelSensor) {
    if (HasFuelSensor != null && HasFuelSensor != undefined
        && HasFuelSensor === false) {
        return "No Sensor";
    }
    else {
        var tempRoundingValue = "2";
        if (FuelLevelQualifier != null && ((FuelLevelQualifier == 'A') || (FuelLevelQualifier == 'P'))) {
            return (FuelLevel != null) ? parseFloat(FuelLevel.toFixed(parseInt(tempRoundingValue))) : "-NA-";
        }
        else {
            return FuelLevelQualifierDesc;
        }
    }
}

function AlarmDescriptionFormatter(params, alarmsList, DeviceType) {
    var element = document.createElement("span");
    if (params != null && params != undefined && params != '') {
        var lstAlarms = params.split(',');
        $.each(lstAlarms, function (index, item) {
            if (item != "" && item != null) {
                if (parseInt(index.toString()) > 0) {
                    var spanElement = document.createElement("span");
                    spanElement.innerText = "\n";//", ";
                    element.appendChild(spanElement);
                }

                if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                    if (DeviceType != null && DeviceType != undefined && DeviceType.toString().trim() == "ST9100") {
                        var alarmDescription = alarmsList.filter(e =>
                            e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                        if (alarmDescription.length == 0) {//added below condition for RCNG-501
                            alarmDescription = alarmsList.filter(e =>
                                e.AlarmCd === item);
                        }
                        var anchorElement = document.createElement("a");
                        //anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                        anchorElement.text = item + " : " + (alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "");
                        anchorElement.style.color = '#F00';
                        element.appendChild(anchorElement);
                    }
                    else {
                    var alarmDescription = alarmsList.filter(e =>
                        e.AlarmAlias === item);
                        if (alarmDescription.length == 0) {//added below condition for RCNG-501
                            alarmDescription = alarmsList.filter(e =>
                                e.AlarmCd === item);
                        }
                    var anchorElement = document.createElement("a");
                    //anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                    anchorElement.text = item + " : " + (alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "");
                    anchorElement.style.color = '#F00';
                        element.appendChild(anchorElement);
                    }
                }
            }
        });       
        return element.outerHTML;
    }

    else return "<span className='colorBlack'> No alarms </span>";

}
function LineFrequencyFormatter(LineFrequency: any, LineFrequencyQualifier: any, ReeferOEMTypeCd: any, ControllerTypeCd: any) {
    if (LineFrequency != null && LineFrequency != undefined) {
        if (ReeferOEMTypeCd.toString().toUpperCase().trim() == "D" && (ControllerTypeCd == 27 || ControllerTypeCd == 28 || ControllerTypeCd == 32)) {
            if (LineFrequencyQualifier != null && (LineFrequencyQualifier == 0 || LineFrequencyQualifier == 1)) {
                if (LineFrequency.toString().trim() == "-999")
                    return "Unknown";
                return parseFloat(LineFrequency).toFixed(1).toString();
            }
            else if (LineFrequencyQualifier != null && LineFrequencyQualifier == 8) {
                //var value = params.value;
                //if(value == 19)
                return "High";
            }
            else if (LineFrequencyQualifier != null && LineFrequencyQualifier == 9) {
                //var value = params.value;
                //if(value == 35)
                return "Low";
            }
            else
                return "Unknown";
        }
        else {
            if (LineFrequency != null) {

                if (LineFrequency.toString().trim() == "-999") 
                    return "OOR";
                else
                    return LineFrequency;
            }

            return "-NA-";
        }
    }
    else {
        if (LineFrequency != null) {

            if (LineFrequency.toString().trim() == "-999") 
                return "OOR";
            else
                return LineFrequency;
        }

        return "-NA-";
    }
}

function SensorDataFormatter(params) {
    if (params != null) {

        if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
            return "OOR";
        else
         return params;
    }

    return "-NA-";
}
function GetTempColumnFormatter() {
    var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
    if (tempUnitCd.toUpperCase() == "F")
        return "(°F)";
    else
        return "(°C)";
}
function GetTimeZoneFormatter() {
    var tempZoneCd = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneCd.trim();
    if (tempZoneCd != null && tempZoneCd != "")
        return "(" + tempZoneCd + ")";
}
function Current3PhaseFormatter(params) {
    var currentValue1 = "";
    var currentValue2 = "";
    var currentValue3 = "";
    if (params != null) {
        var phases = params.split(",");
        if (phases[0].toString().trim() == "-999")
            currentValue1 = "OOR";
        else
            currentValue1 = phases[0].toString().trim();
        if (phases[1].toString().trim() == "-999")
            currentValue2 = "OOR";
        else
            currentValue2 = phases[1].toString().trim();
        if (phases[2].toString().trim() == "-999")
            currentValue3 = "OOR";
        else
            currentValue3 = phases[2].toString().trim();

        return currentValue1 + ", " + currentValue2 + ", " + currentValue3;
    }
    else
        return "";
}

function preTripFormatter(params) {    
    var imagePath = "";
    if (params != null && params != undefined && params != '') {
        switch (params.toString().trim()) {
            case 'Passed':
            case 'OK':
                imagePath = passed;
                break;
            case 'Failed':
            case 'NG':
                imagePath = failed;
                break;
            case 'Aborted':
                imagePath = aborted;
                break;
            case 'Running':
                imagePath = runningtime;
                break;
            case 'Unknown':
                imagePath = questionMark;
                break;
        }
    }
    return imagePath;
}

function fillLevelTrace(params) {
    if (params.HasFuelSensor != null && params.HasFuelSensor != undefined
        && params.HasFuelSensor === false) {
        return "No Sensor";
    }
    else {
        if (params != null && params != undefined && params != '') {
            if (params.HasFuelSensor != null && params.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.FuelLevelQualifier != null && ((params.FuelLevelQualifier == 'A') || (params.FuelLevelQualifier == 'P'))) {
                    if (params.FuelLevelTierNumber != null) {
                        return "../images/FuelGaugeFractionImages/" + params.FractionDisplayGif;
                    }
                    else {
                        if (params.FuelLevelPct != null) {
                            var tempRoundingValue = "2";
                            return parseFloat(params.FuelLevelPct.toFixed(parseInt(tempRoundingValue))) + " %";
                        }
                        else {
                            return "FRU";
                        }
                    }
                }
                else {
                    if (params.FuelLevelQualifier == "S")
                        return "FSE";
                    else
                        return params.FuelLevelQualifierDesc;
                }
            }
            else
                return "-NA-";
        }
        else
            return '-NA-';
    }
}

function sensorDataPCondFormatter(ReeferOEMypeCd, CondenserPressure) {
    if (ReeferOEMypeCd != null && ReeferOEMypeCd != undefined && ReeferOEMypeCd != '' && CondenserPressure != null && CondenserPressure != undefined && CondenserPressure != '') {
        if (ReeferOEMypeCd != null && ReeferOEMypeCd != '') {
            if (ReeferOEMypeCd.trim() == 'C')
                return '-NA-';
            else {
                if (CondenserPressure != null) {
                    if (CondenserPressure.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                        return "OOR";
                    else
                        return CondenserPressure.toString();
                }
                else
                    return '-NA-';
            }
        }
        return '-NA-';
    }
    return '-NA-';
}

function pwrStateFormatter(DevicePowerSourceCd, DeviceConfig) {    
    if (DevicePowerSourceCd != null && DevicePowerSourceCd != undefined) {        
        if (DevicePowerSourceCd == "B") {
            return "On Battery";            
        }
        else if (DeviceConfig != null && DeviceConfig != undefined && DeviceConfig.toString().toUpperCase().trim() == "TRUE" && DevicePowerSourceCd == "A") {
            return "Charging";
        }
        else {
            return "Powered";
        }
    }
    return '-NA-';
}

function pwrStateFormatterChassis(params) {
    //return "-NA-";
    //var imagePath = "";
    //if (params != null && params != undefined && params != '') {
    //    switch (params.toString().toUpperCase().trim()) {
    //        case "C":
    //            imagePath = batterycritical;
    //            break;
    //        case "L":
    //            imagePath = batterylow;
    //            break;
    //        case "N":
    //            imagePath = batterynormal;
    //            break;
    //    }
    //}
    //return imagePath;
    if (params != null && params != undefined && params != '') {
        if (params.trim() == "A") return "Powered";
        else if (params.trim() == "B") return "On Battery";
        else return "-NA-";
    }
    return "-NA-";
}
function ChassisBatteryStatusFormatter(params) {  
    if (params != null && params != undefined && params != '') {      
        if (params.toString().toUpperCase().trim() == "C") {
            return "Critical";
        }
        else if (params.toString().toUpperCase().trim() == "L") {
            return "Low";
        }
        else if (params.toString().toUpperCase().trim() == "N") {
            return "Normal";
        }
        return "-NA-";
    }
    return "-NA-";
}
function BrakeSignalFormatter(params) {

    return "-NA-";
}
function LoadedFormatter(params) {
    if (params != null && params != undefined) {
        if (params.toString().toUpperCase().trim() == "TRUE")
            return "Loaded";
        else
            return "Empty";
    }
    else
        return '-NA-';
}

function DoorFormatterChassis(HasDoorSensor, Door1OpenChassis) {
    if (HasDoorSensor != null && HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
        if (Door1OpenChassis != null && Door1OpenChassis != undefined) {
            if (Door1OpenChassis.toString().toUpperCase().trim() == "TRUE")
                return "Open";
            else
                return "Closed";
        }
        else
            return "Unknown";
    }
    else
        return "No Sensor";
} 
function FloatTypeFormatter(params) {
    if (params != null && params != undefined) {
        return params;
    }
    else
        return '-NA-';
}
function BattVoltageFormatter(params) {
    var tempRoundingValue = "1";
    if (params != null && params != undefined) {
        return params.toFixed(parseInt(tempRoundingValue));
    }
    else
        return '-NA-';
}
function HumiditySetpointFormatter(params) {
    if (params != null && params != undefined) {
        if (params.toString().trim() == "0")
            return "Off";
        else if (params.toString().trim() == "-999") 
            return "OOR";
        else
            return params;
    }
    return "-NA-";
}

